// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"742":"28042595","3831":"28042595","6262":"a823149d","7701":"29576072","9520":"29576072","9707":"6a37a1ed"}[chunkId] + ".chunk.css";
};